import { useState } from "react";
import { Gender } from "emt-web/src/dataV3/Common/Gender";

export type GenderButtonType = Gender.male | Gender.female | "all";

export function useGenderButton(state: GenderButtonType) {
  const [activeGenderButton, setActiveGenderButton] =
    useState<GenderButtonType>(state);
  return [activeGenderButton, setActiveGenderButton] as const;
}
